import { createContext } from "react";

const TargetContext = createContext();

export { TargetContext };